export default {
  gql: {
    GET_INTERESTS: `
      query GetAccountInterests($golfId: String!) {
        getAccountInterests(golfId: $golfId) {
          id
          name
        }
      }
    `,
    GET_ACCOUNT_BY_TOKEN: `
    query GetAccountByToken($token: String!) {
      getAccountByToken(token: $token) {
        id
        firstname
        lastname
        email
        phone
        covidCertificate
        ffg {
          license
          handicap
          handicapDate
        }
        matches {
          golfId
          reference
          isMember
          isFavorite
          token
        }
      }
    }
    `,
    SET_INTERESTS: `
      mutation SetAccountInterests(
        $golfId: String!
        $interestIds: [Int]!
      ) {
        setAccountInterests(
          golfId: $golfId
          interestIds: $interestIds
        ) {
          success
        }
      }
    `,
    GET_STATEMENT: `
      query GetAccountStatement($golfId: String!) {
        getAccountStatement(
          golfId: $golfId
        ) {
          balance
          receipts {
            date
            name
            total
            balance
            details {
              name
              amount
            }
          }
        }
      }
    `,
    GET_INFO_PRIMA: `
      query GetAccountPrima($golfId: String!) {
        getAccountPrima(
          golfId: $golfId
        ) {
          city
          address
          address2
          postcode
          addressIsValidated
          privacy {
            beAnonymousOnSchedule
            doNotAppearInDirectory
            hideContactDetailsInDirectory
          }
        }
      }
    `,
    SET_INFO_PRIMA: `
      mutation SetAccountPrima(
        $city: String
        $golfId: String!
        $address: String
        $address2: String
        $postcode: String
      ) {
        setAccountPrima(
          city: $city
          golfId: $golfId
          address: $address
          address2: $address2
          postcode: $postcode
        ) {
          success
        }
      }
    `,
    // -------------------------------------------------------------------------
    // DEPRECATED
    // -------------------------------------------------------------------------
    // SET_PRIVACY: `
    //   mutation(
    //     $golfId: String!
    //     $isPrivate: Boolean!
    //   ) {
    //     setAccountPrivacy(
    //       golfId: $golfId
    //       isPrivate: $isPrivate
    //     ) {
    //       success
    //     }
    //   }
    // `,
    SET_PRIVACY: `
      mutation SetAccountPrivacy(
        $golfId: String!
        $beAnonymousOnSchedule: Boolean!
        $doNotAppearInDirectory: Boolean!
        $hideContactDetailsInDirectory: Boolean!
      ) {
        setAccountPrivacy(
          golfId: $golfId
          beAnonymousOnSchedule: $beAnonymousOnSchedule
          doNotAppearInDirectory: $doNotAppearInDirectory
          hideContactDetailsInDirectory: $hideContactDetailsInDirectory
        ) {
          success
        }
      }
    `,
    MATCH_ACCOUNT: `
      mutation MatchAccount($golfId: String!) {
        matchAccount(golfId: $golfId) {
          success
        }
      }
    `,
    SET_COVID_CERTIFICATE_OWNED: `
      mutation SetCovidCertificateOwned(
        $id: String!
      ) {
        setCovidCertificateOwned(
          id: $id
        ) {
          success
        }
      }
    `,
    GET_HCP_INDEX_FFG: `
      query GetAccountIndexFFG {
        getAccountIndexFFG {
          license
          handicap
          handicapDate
        }
      }
    `,
  },
};
